module.exports = __webpack_public_path__ + "img/T622.52562a12.jpg";